// @flow

// Turf
import turfFlatten from '@turf/flatten'

// Utils & Constants
import traverse from 'fc-utils/traverse'

import {
  // Model Properties
  PROP_SHAPE,
  PROP_SEASON,

  // Utils
  isSeasonal,
} from 'fc-model-assets'

import {
  PROP_SHAPE_DATA,
} from 'fc-model-shapes'

// Local Utils
const getGeoJSON = traverse([PROP_SHAPE, PROP_SHAPE_DATA, JSON.parse])

// Exports
export default function preProcessor (
  json: Array<Object>,
  { queryParams }: { queryParams: ?Object } = {}
): Array<Object> {
  // If assets were queried by season id
  if (queryParams && queryParams.season) {
    const seasonId = Number(queryParams.season)

    if (Array.isArray(json)) {
      return json.map(function (assetJson: Object): Object {
        // If the asset is a seasonal asset add the season id to its raw json
        const geoJSON = getGeoJSON(assetJson)
        const flattened = geoJSON ? turfFlatten(geoJSON) : null

        const nextJSON = geoJSON
          ? {
            ...assetJson,
            [PROP_SHAPE]: {
              ...assetJson[PROP_SHAPE],
              [PROP_SHAPE_DATA]: JSON.stringify({
                ...flattened,
                features: flattened.features.map(function (feature: Object, featureIndex: number): Object {
                  return {
                    ...feature,
                    properties: {
                      ...feature.properties,
                      featureIndex,
                    },
                  }
                }),
              }),
            },
          }
          : assetJson

        if (isSeasonal(nextJSON)) {
          return {
            ...nextJSON,
            [PROP_SEASON]: seasonId,
          }
        }

        return nextJSON
      })
    } else if (isSeasonal(json)) {
      const geoJSON = getGeoJSON(json)
      const flattened = geoJSON ? turfFlatten(geoJSON) : null

      const nextJSON = geoJSON
        ? {
          ...json,
          [PROP_SHAPE]: {
            ...json[PROP_SHAPE],
            [PROP_SHAPE_DATA]: JSON.stringify({
              ...flattened,
              features: flattened.features.map(function (feature: Object, featureIndex: number): Object {
                return {
                  ...feature,
                  properties: {
                    ...feature.properties,
                    featureIndex,
                  },
                }
              }),
            }),
          },
        }
        : json

      return {
        ...nextJSON,
        [PROP_SEASON]: seasonId,
      }
    }
  }

  return json
}
